import React, { useMemo, useState } from 'react'
import { FormStyle, Description, LinkUnderline, Bg } from './style'
import { Title } from '../../style'
import { useForm } from 'react-hook-form'
import { getEmail, getLogin } from '../../thunk'
import { useDispatch, useSelector } from 'react-redux'
import Input from 'components/Form/Input'
import { ButtonFull } from 'components/Form/Button'
import Checkbox from 'components/Form/Checkbox'
import { showPopup } from 'components/Modal/slices'
import * as yup from 'yup'
import { useYupValidationResolver, SS } from 'utils/common'
import { FormattedMessage, useIntl } from 'react-intl'
import { isAuth } from 'utils/auth'
import { push } from 'connected-react-router'

const Form = ({
	shopId,
	locale,
	orderId = '',
	email = '',
	themeName,
	managerUsername = '',
}) => {
	const intl = useIntl()
	const [orderNum, setOrderNum] = useState(!!orderId)
	const validationSchema = useMemo(
		() =>
			yup.object().shape({
				email: yup
					.string()
					.email('Invalid email address')
					.required('Required')
					.trim(),
				orderId: yup.string().trim(),
				termAndCond: yup
					.boolean()
					.oneOf([true], 'Must Accept Terms and Conditions'),
			}),
		[]
	)

	const {
		register,
		handleSubmit,
		errors,
		watch,
		formState: { isValid },
	} = useForm({
		resolver: useYupValidationResolver(validationSchema),
		defaultValues: {
			email: email || '', //ruslan.gladyshev@returnado.com
			orderId: orderId || '', //26350961
		},
	})

	const { terms, policy } = useSelector((state) => state.login)

	const dispatch = useDispatch()

	const onSubmit = (data) => {
		/*TODO: ATTENTION! for local development we aere using 'rootShopId', but */
		if (locale && shopId) {
			let dataLogin = {
				email: data.email.replace(/\+/g, '%2B'),
				language: locale,
				shopId: shopId,
			}
			if (managerUsername) {
				dataLogin.managerUsername = managerUsername
			}
			if (data.orderId) {
				dataLogin.orderId = data.orderId.replace(/\#/g, '%23')
				dispatch(getLogin(dataLogin))
				SS.set('loginOrderId', dataLogin.orderId.replace('%23', '#'))
			} else {
				dispatch(getEmail(dataLogin))
			}
		} else {
			console.alert(`Locale is "${locale}" / shopId is ${shopId}`)
		}
	}
	const redirectToOrder = () => {
		dispatch(push('/orders'))
	}

	const openPolicyPopupWindow = (e) => {
		e.preventDefault()
		dispatch(
			showPopup({
				type: 'policy',
				data: policy,
			})
		)
	}
	const openTermsPopupWindow = (e) => {
		e.preventDefault()
		dispatch(
			showPopup({
				type: 'terms',
				data: terms,
			})
		)
	}

	return (
		<Bg className='col-md-6 col-sm-12'>
			<FormStyle onSubmit={handleSubmit(onSubmit)} noValidate>
				<Title>
					<FormattedMessage
						id='login.intro.header'
						defaultMessage='NOT SATISFIED WITH YOUR PURCHASE?'
					/>
				</Title>
				<Description>
					<FormattedMessage
						id='login.intro.reconversion.enabled.text'
						defaultMessage='Through Returnado you can register a return or find
					replacement products, sign in with the email address you
					used when ordering.'
					/>
				</Description>
				{isAuth() ? (
					<>
						<ButtonFull
							uppercase='true'
							w100
							type='button'
							className='mb-4'
							onClick={redirectToOrder}
						>
							<FormattedMessage
								id='login.my.orders.button'
								defaultMessage='My orders'
							/>
						</ButtonFull>
						<div>
							<FormattedMessage
								id='login.form.termsAndConditions'
								defaultMessage="I accept Returnado's"
							/>{' '}
							<LinkUnderline href='google.com' target='_blank'>
								<FormattedMessage
									id='login.form.termsAndConditions.link'
									defaultMessage='Terms and Conditions'
								/>
							</LinkUnderline>{' '}
							<FormattedMessage
								id='login.form.termsAndConditions.label'
								defaultMessage='and'
							/>{' '}
							<LinkUnderline href='google.com' target='_blank'>
								<FormattedMessage
									id='login.form.privacyPolicy.link'
									defaultMessage='Privacy Policy'
								/>
							</LinkUnderline>
						</div>
					</>
				) : (
					<>
						<Input
							type='email'
							name='email'
							placeholder={intl.formatMessage({
								id: 'login.form.email.placeholder',
								defaultMessage: 'Enter your e-mail',
							})}
							register={register}
							error={errors.email}
							className='mb-3'
						/>
						{themeName !== 'asket' && (
							<div className='flex justify-content-end'>
								<LinkUnderline
									orderNum={orderNum}
									orderLink
									as='div'
									onClick={() => setOrderNum(!orderNum)}
								>
									<FormattedMessage
										id='login.form.order.link'
										defaultMessage='Log in with order number?'
									/>
								</LinkUnderline>
							</div>
						)}

						{(orderNum || themeName === 'asket') && (
							<Input
								type='text'
								name='orderId'
								placeholder={intl.formatMessage({
									id: 'login.form.order.placeholder',
									defaultMessage: 'Enter your order number',
								})}
								register={register}
								error={errors.orderId}
								className='mb-4'
							/>
						)}
						<ButtonFull
							uppercase='true'
							w100
							type='submit'
							className='mb-4'
						>
							{watch('email') && !watch('orderId') ? (
								<FormattedMessage
									id='login.form.login.button.onlyEmail'
									defaultMessage='E-MAIL ME LINK'
								/>
							) : (
								<FormattedMessage
									id='login.form.login.button.text'
									defaultMessage='VIEW ORDER'
								/>
							)}
						</ButtonFull>
						<Checkbox
							register={register}
							name='termAndCond'
							error={errors.termAndCond}
						>
							<FormattedMessage
								id='login.form.termsAndConditions'
								defaultMessage="I accept Returnado's"
							/>{' '}
							{!!terms && (
								<LinkUnderline onClick={openTermsPopupWindow}>
									<FormattedMessage
										id='login.form.termsAndConditions.link'
										defaultMessage='Terms and Conditions'
									/>
								</LinkUnderline>
							)}{' '}
							{!!policy &&
								`${intl.formatMessage({
									id: 'login.form.termsAndConditions.label',
									defaultMessage: 'and',
								})} `}
							{!!policy && (
								<LinkUnderline onClick={openPolicyPopupWindow}>
									<FormattedMessage
										id='login.form.privacyPolicy.link'
										defaultMessage='Privacy Policy'
									/>
								</LinkUnderline>
							)}
						</Checkbox>
					</>
				)}
			</FormStyle>
		</Bg>
	)
}
export default Form
